import React from "react";

const LangFormatter = ({ langCode, nativeName, translated = true }) => {
    const setIconView = () => {
        let img;
        try {
            img = require("../../assets/images/icon/langs/" + langCode + ".png");
        } catch (e) {
            img = require("../../assets/images/icon/langs/default.jpeg");
        }
        return img;
    }

    return (
        <img className={`lang-flag-table ${!translated ? 'grayscale' : ''}`} src={setIconView()} alt={nativeName}/>
    );
}

export default LangFormatter;